<template>
	<div class="switch-box content">
		<div class="switch-item" :class="[{ 'switch-active': i == value, 'switch-phone-item': is_phone },is_phone?'fs-18':'fs-20']" v-for="(v, i) in list" :key="i" @click="clickItem(i)">
			{{ rangeKey ? v[rangeKey] : v }}
		</div>
	</div>
</template>

<script>
export default {
	name: '',
	model: {
		prop: 'value', //prop代表着我要和props的那个变量相对应
		event: 'input' //event表示着事件，我触发事件cc的时候会改变父组件v-model的值。
	},
	props: {
		value: {}, //当前选中
		list: {}, //渲染列表
		rangeKey: {} //渲染键
	},
	data() {
		return {
			timer: null,
			timer2: null
		};
	},
	created() {},
	mounted() {
		this.pay();
	},
	watch: {
		list() {
			this.pay();
		}
	},
	destroyed() {
		clearInterval(this.timer);
	},
	methods: {
		stop(text = '外部暂停') {
			this.$debug && console.log(text);
			this.timer && clearInterval(this.timer);
		},
		// 自动切换
		pay() {
			this.stop('播放前清除定时器');
			this.$debug && console.log('播放');
			if (this.list.length == 0) return;
			this.timer = setInterval(() => {
				let value = this.value == this.list.length - 1 ? 0 : this.value + 1;
				this.$emit('input', value);
			}, 5000);
		},
		// 点击切换
		clickItem(i) {
			this.$emit('input', i);
			this.stop('切换暂停');
		}
	}
};
</script>

<style scoped="scoped">
.switch-box {
	display: flex;
	align-items: center;
	justify-content: center;
}
.switch-item {
	color: #666666;
	padding: 0 0.6rem;
	border-left: 1px solid #cfcfcf;
	cursor: pointer;
	transition: all .5s;
}
.switch-item:nth-child(1) {
	border-left: none;
}
.switch-phone-item {
	flex: 1;
	text-align: center;
	padding: 0;
}
.switch-active {
	color: #000000;
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/SwitchBar.vue